/* eslint-disable
    consistent-return,
    no-alert,
    no-var,
    one-var,
    react/no-danger,
    vars-on-top
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS101: Remove unnecessary use of Array.from
 * DS102: Remove unnecessary code created because of implicit returns
 * DS205: Consider reworking code to avoid use of IIFEs
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import classNames from 'classnames';
import $ from 'jquery';
import _ from 'underscore';
import React from 'react';
import createReactClass from 'create-react-class';
import reactUpdate from 'immutability-helper';
import {CSSTransitionGroup} from 'react-transition-group';
import ReactDOM from 'react-dom';
import Col from 'ui-library/bs/Col';
import Row from 'ui-library/bs/Row';
import EditableListMixin from 'notebook/mediocre/selection/text/EditableListMixin';
import Button, {ButtonSize, ButtonStyle} from 'ui-library/buttons/Button';
import BenchlingIcon from 'ui-library/icons/BenchlingIcon';

import PropTypes from 'prop-types';

import ProtocolActions from 'notebook/protocols/actions/ProtocolActions';
import formatters from 'notebook/mediocre/formatted-text/formatters';
import WithSpreadsheetEvaluationUserMixin from 'notebook/tables/spreadsheets/WithSpreadsheetEvaluationUserMixin';
import MenuIcon from 'notebook/protocols/viewer/MenuIcon';
import * as parseutil from 'notebook/protocols/ParseUtil';
import {StepLevel} from 'notebook/protocols/StepConstants';
import * as TransitionConstants from 'ui-library/TransitionConstants';
import {protocolSpreadsheetComponentWillReceiveProps} from 'notebook/protocols/editor/ProtocolSpreadsheetUtil';
import StepImage from 'notebook/protocols/viewer/StepImage';
import StepTable from 'notebook/protocols/viewer/StepTable';
import Material from 'notebook/protocols/viewer/Material';
import SBSTimers from 'notebook/protocols/viewer/SBSTimers';
import AggregateTimeComponent from 'notebook/protocols/viewer/AggregateTimeComponent';
import * as AudioBeep from 'notebook/protocols/viewer/AudioBeep';
import StepEmphasis from 'notebook/protocols/viewer/StepEmphasis';

const {renderEmphasis} = StepEmphasis;

import TimerComponent from 'notebook/protocols/viewer/TimerComponent';
import ToolboxActiveTimer from 'notebook/protocols/viewer/ToolboxActiveTimer';
import Checkbox from 'notebook/protocols/viewer/Checkbox';
import * as util from 'BenchlingUtil';

const LOCAL_ID_PREFIX = 'ctimer-';
const MAX_TIMER_NAME = 60;

function shortenTimerName(fullName) {
  if (fullName.length <= MAX_TIMER_NAME) {
    return fullName;
  }
  return `${fullName.slice(0, MAX_TIMER_NAME)}...`;
}

const ProtocolStepByStep = createReactClass({
  mixins: [WithSpreadsheetEvaluationUserMixin, EditableListMixin],

  getInitialState() {
    return {
      showMenu: false,
      showTimers: false,
      createTimerPrefill: null,
      trayTimers: [],
      inlineTimers: this.aggregateStepTimers(this.props),
      inlineTrayIDs: [],
    };
  },

  propTypes: {
    closeStepByStep: PropTypes.func.isRequired,
    protocol: PropTypes.object.isRequired,
  },

  aggregateStepTimers(props) {
    let lastText = 'Inline Timer';
    const items = (() => {
      const result = [];
      for (const step of Array.from(props.protocol.steps)) {
        if ([StepLevel.HEADER, StepLevel.STEP, StepLevel.DESC].includes(step.level)) {
          lastText = shortenTimerName(step.text);
          continue;
        }
        if (step.level !== StepLevel.TIMER) {
          continue;
        }
        const timer = this.newTimer(true, step.id, lastText, step.timer.milliseconds);
        result.push([step.id, timer]);
      }
      return result;
    })();
    return _.object(items);
  },

  newTimer(inline, id, name, originalMS) {
    const changeFunction = inline ? this.updateInlineTimer : this.updateTimer;
    const deleteFunction = inline ? this.deleteInlineTimer : this.deleteTimer;
    return {
      id,
      name,
      startMS: originalMS,
      startMoment: null,
      originalMS,
      requestChange: changeFunction.bind(this, id),
      requestDelete: deleteFunction.bind(this, id),
    };
  },

  updateTimer(id, properties) {
    if (properties.name) {
      properties.name = shortenTimerName(properties.name);
    }
    const newTimers = Array.from(this.state.trayTimers).map((timer) =>
      timer.id === id ? reactUpdate(timer, {$merge: properties}) : timer
    );
    this.setState({trayTimers: newTimers});
  },

  deleteTimer(id) {
    this.setState({
      // eslint-disable-next-line no-restricted-syntax
      trayTimers: _.filter(this.state.trayTimers, (timer) => timer.id !== id),
    });
  },

  updateInlineTimer(id, properties) {
    // Always update the inline timer state.
    const newTimers = reactUpdate(this.state.inlineTimers, _.object([[id, {$merge: properties}]]));
    this.setState({inlineTimers: newTimers});
    // If starting, make sure it's in the tray.
    const starting = properties.startMoment != null;
    if (starting && !Array.from(this.state.inlineTrayIDs).includes(id)) {
      const inlineTrayIDs = reactUpdate(this.state.inlineTrayIDs, {$push: [id]});
      this.setState({inlineTrayIDs});
    }
  },

  deleteInlineTimer(id) {
    this.setState({
      // eslint-disable-next-line no-restricted-syntax
      inlineTrayIDs: _.filter(this.state.inlineTrayTrimers, (timerID) => timerID !== id),
    });
  },

  createTrayTimer(name, originalMS) {
    const newTimer = this.newTimer(false, _.uniqueId(LOCAL_ID_PREFIX), name, originalMS);
    this.setState({
      trayTimers: reactUpdate(this.state.trayTimers, {$push: [newTimer]}),
      showTimers: true,
    });
  },

  allTrayTimers() {
    const inlineTimers = Array.from(this.state.inlineTrayIDs).map((id) =>
      // eslint-disable-next-line no-restricted-syntax
      _.extend({playAudio: false, inlineCopy: true}, this.state.inlineTimers[id])
    );
    const trayTimers = Array.from(this.state.trayTimers).map((timer) =>
      // eslint-disable-next-line no-restricted-syntax
      _.extend({playAudio: false, inlineCopy: false}, timer)
    );
    return [].concat(inlineTimers, trayTimers);
  },

  activeTrayTimer() {
    let out = null;
    let earliestEnd = null;
    for (const timer of Array.from(this.allTrayTimers())) {
      // Done timer always wins.
      var end;
      if (timer.startMS === 0) {
        // High priority end by using timestamp of 0
        end = 0;
        // Non-inline timer has priority over inline timer so that we can play the audio.
        if (earliestEnd == null || end < earliestEnd || (out.inlineCopy && !timer.inlineCopy)) {
          out = timer;
          earliestEnd = end;
        }
        continue;
      }
      if (!timer.startMoment) {
        continue;
      }
      end = timer.startMoment.unix() * 1000 + timer.startMS;
      if (earliestEnd == null || end < earliestEnd) {
        out = timer;
        earliestEnd = end;
      }
    }
    return out;
  },

  timerRunning() {
    for (const timer of Array.from(this.allTrayTimers())) {
      if (timer.startMoment) {
        return true;
      }
    }
    return false;
  },

  checkTimersBefore(callback) {
    return () => {
      if (this.timerRunning()) {
        if (
          !window.confirm(`You have one or more timers running - are you sure you want to leave this \
page?`)
        ) {
          return;
        }
      }
      callback.call(this);
    };
  },

  componentDidUpdate() {
    if (this.timerRunning()) {
      window.onbeforeunload = function () {
        window.beforeUnloadType = 'step-by-step';
        return 'You have one or more timers running!';
      };
    } else {
      window.onbeforeunload = null;
    }
  },

  UNSAFE_componentWillReceiveProps(nextProps) {
    protocolSpreadsheetComponentWillReceiveProps(this.props, nextProps, this.setMultiEditingForTable);
  },

  toggleComplete(step) {
    if (step.completed) {
      ProtocolActions.resetStep(this.props.protocol.id, step.id);
    } else {
      ProtocolActions.completeStep(this.props.protocol.id, step.id);
    }
  },

  toggleMenu() {
    return this.setState({
      showMenu: !this.state.showMenu,
      showTimers: false,
    });
  },

  toggleTimers() {
    const audioNode = ReactDOM.findDOMNode(this.refs.audio);
    // We need to play/pause the audio in a user event prior to playing it when time is out,
    // so we do it here to ensure it's been played prior to a tray timer going off.
    AudioBeep.prime(audioNode);
    this.setState({
      showMenu: false,
      showTimers: !this.state.showTimers,
    });
  },

  playAudio() {
    return ReactDOM.findDOMNode(this.refs.audio).play();
  },
  pauseAudio() {
    return ReactDOM.findDOMNode(this.refs.audio).pause();
  },

  materialsNavID: 'sbs-materials',

  stepNavID(step) {
    return `sbs-${step.id}`;
  },

  openTimerTrayWithPrefill(step) {
    this.setState({
      createTimerPrefill: {
        name: shortenTimerName(step.text),
        originalMS: step.time_seconds * 1000,
      },
      showTimers: true,
    });
  },

  renderNumberedStep(step, i) {
    return (
      <ol key={step.id} id={this.stepNavID(step)}>
        <li value={i}>
          <div className="step-inner-div" onClick={this.toggleComplete.bind(this, step)}>
            <Checkbox checked={step.completed} />
            <span
              dangerouslySetInnerHTML={{
                __html: renderEmphasis(
                  step.type,
                  formatters.renderHTML(step.text, step.formats, {
                    processText: parseutil.parseHTML,
                  })
                ),
              }}
            />
          </div>
          {step.time_seconds ? (
            <AggregateTimeComponent
              timeSeconds={step.time_seconds}
              onClick={this.openTimerTrayWithPrefill.bind(this, step)}
            />
          ) : undefined}
        </li>
      </ol>
    );
  },

  resetTasks(e) {
    if (!window.confirm('Are you sure you want to clear all progress?')) {
      e.stopPropagation();
      return;
    }
    ProtocolActions.resetAllSteps(this.props.protocol.id);
  },

  renderMenu() {
    let i = 0;
    return (
      <div className="step-by-step-menu-container">
        <ul className="step-by-step-menu">
          <li className="section-title">
            <a href={`#${this.materialsNavID}`}>Materials</a>
          </li>
          {(() => {
            const result = [];
            for (const step of Array.from(this.props.protocol.steps)) {
              const anchorAttrs = {href: `#${this.stepNavID(step)}`};
              switch (step.level) {
                case StepLevel.HEADER:
                  result.push(
                    <li className="section-title">
                      <a
                        // eslint-disable-next-line no-restricted-syntax
                        {..._.extend(anchorAttrs, {
                          dangerouslySetInnerHTML: {
                            __html: formatters.renderHTML(step.text, step.formats, {
                              processText: parseutil.parseHTML,
                            }),
                          },
                        })}
                      />
                    </li>
                  );
                  break;
                case StepLevel.STEP: {
                  i++;
                  const html = formatters.renderHTML(step.text, step.formats, {
                    processText: parseutil.parseHTML,
                  });
                  let text = $('<div>').append(html).text();
                  const MAX_LENGTH = 150;
                  if (text.length > MAX_LENGTH) {
                    text = `${text.substring(0, MAX_LENGTH)}...`;
                  }
                  result.push(
                    <li>
                      <a {...anchorAttrs}>
                        <span className="step-number">{i}</span>
                        <span>{text}</span>
                      </a>
                    </li>
                  );
                  break;
                }
                default:
                  result.push(undefined);
              }
            }
            return result;
          })()}
        </ul>
        <div className="sbs-menu-buttons">
          <Row>
            <Col sm={6}>
              <Button
                buttonStyle={ButtonStyle.TERTIARY_GRAY}
                size={ButtonSize.MEDIUM}
                text="Reset Steps"
                onClick={this.resetTasks}
              />
            </Col>
            <Col sm={6}>
              <Button
                buttonStyle={ButtonStyle.SECONDARY}
                size={ButtonSize.MEDIUM}
                text="Exit"
                onClick={this.checkTimersBefore(this.props.closeStepByStep)}
              />
            </Col>
          </Row>
        </div>
      </div>
    );
  },

  // Height (score) of a material = 1 name
  //   + # components + 1 extra for larger name and margin above.
  _scoringFunction(material) {
    return material.components.length + 2;
  },

  renderMaterialsList(materials) {
    let i, material;
    if (materials.length === 0) {
      return null;
    }
    let secondColumnI = 0;
    let currentScore = 0;
    const totalScore = util.sum(materials.map((mat) => this._scoringFunction(mat)));
    let minScoreDiff = Infinity;
    // Find column break index that minimizes difference between
    // the heights (scores) of first and second columns.
    for (i = 0; i < materials.length; i++) {
      material = materials[i];
      currentScore += this._scoringFunction(material);
      const scoreDiff = Math.abs(totalScore - currentScore - currentScore);
      if (minScoreDiff > scoreDiff) {
        minScoreDiff = scoreDiff;
        secondColumnI = i + 1;
      }
    }

    const firstColumnMaterials = [];
    const secondColumnMaterials = [];
    for (i = 0; i < materials.length; i++) {
      material = materials[i];
      material = (
        <Material
          key={material.id}
          components={material.components}
          formats={material.formats}
          name={material.name}
        />
      );
      if (i < secondColumnI) {
        firstColumnMaterials.push(material);
      } else {
        secondColumnMaterials.push(material);
      }
    }
    return (
      <div>
        <h2 id={this.materialsNavID}>Materials</h2>
        <div className="materials-list-wrapper">
          <Row>
            <Col sm={6}>
              <ul className="materials-list">{firstColumnMaterials}</ul>
            </Col>
            <Col sm={6}>
              <ul className="materials-list">{secondColumnMaterials}</ul>
            </Col>
          </Row>
        </div>
      </div>
    );
  },

  render() {
    let i = 0;
    const children = [];
    if (this.state.showMenu) {
      children.push(
        <div key="menu" className="step-by-step-menu-wrapper" onClick={this.toggleMenu} ref="menu">
          {this.renderMenu()}
        </div>
      );
    }
    if (this.state.showTimers) {
      children.push(
        <div key="alarms">
          <SBSTimers
            timers={this.allTrayTimers()}
            createTimer={this.createTrayTimer}
            createTimerPrefill={this.state.createTimerPrefill}
            onRequestClose={this.toggleTimers}
          />
        </div>
      );
    }
    children.push(
      <div key="main-container" className="container">
        <div className="row">
          <div className="col-sm-12">
            {this.renderMaterialsList(this.props.protocol.materials)}
            {(() => {
              const result = [];
              for (let index = 0; index < this.props.protocol.steps.length; index++) {
                const step = this.props.protocol.steps[index];
                switch (step.level) {
                  case StepLevel.HEADER:
                    result.push(
                      <h2 key={step.id} id={this.stepNavID(step)}>
                        <div
                          dangerouslySetInnerHTML={{
                            __html: renderEmphasis(
                              step.type,
                              formatters.renderHTML(step.text, step.formats, {
                                processText: parseutil.parseHTML,
                              })
                            ),
                          }}
                        />
                        {step.time_seconds ? (
                          <AggregateTimeComponent
                            timeSeconds={step.time_seconds}
                            onClick={this.openTimerTrayWithPrefill.bind(this, step)}
                          />
                        ) : undefined}
                      </h2>
                    );
                    break;
                  case StepLevel.STEP:
                    i++;
                    result.push(this.renderNumberedStep(step, i));
                    break;
                  case StepLevel.DESC: {
                    const html = renderEmphasis(
                      step.type,
                      formatters.renderHTML(step.text, step.formats, {
                        processText: parseutil.parseHTML,
                      })
                    );
                    result.push(
                      <p
                        key={step.id}
                        dangerouslySetInnerHTML={{
                          __html: html,
                        }}
                      />
                    );
                    break;
                  }
                  case StepLevel.TABLE:
                    result.push(
                      <StepTable
                        key={step.id}
                        table={step.table}
                        // eslint-disable-next-line react/prop-types
                        computedTable={this.props.computedTables[step.table.name]}
                      />
                    );
                    break;
                  case StepLevel.IMAGE:
                    result.push(<StepImage key={step.id} image={step.image} />);
                    break;
                  case StepLevel.TIMER:
                    result.push(
                      <TimerComponent
                        // eslint-disable-next-line no-restricted-syntax
                        {..._.extend({inline: false, key: step.id}, this.state.inlineTimers[step.id])}
                      />
                    );
                    break;
                  default:
                    result.push(undefined);
                }
              }
              return result;
            })()}
          </div>
        </div>
      </div>
    );
    const activeTimer = this.activeTrayTimer();
    return (
      <div className="step-by-step-viewer">
        <div className="sbs-toolbar u-vertical-center-items">
          <Button
            buttonStyle={ButtonStyle.TERTIARY_WHITE}
            size={ButtonSize.MEDIUM}
            icon="close"
            className="sbs-toolbar-close"
            onClick={this.checkTimersBefore(this.props.closeStepByStep)}
          />
          <div className="toolbox">
            <a
              className={classNames({
                'toolbox-btn': true,
                active: this.state.showMenu,
              })}
              onClick={this.toggleMenu}
            >
              <MenuIcon />
            </a>
            <a
              className={classNames({
                'toolbox-btn': true,
                active: this.state.showTimers,
                ticking: activeTimer != null,
              })}
              onClick={this.toggleTimers}
            >
              <BenchlingIcon icon="clock" />
            </a>
            <AudioBeep.Component ref="audio" />
            {activeTimer != null ? (
              <ToolboxActiveTimer
                timer={activeTimer}
                onClick={this.toggleTimers}
                onRequestPlayAudio={this.playAudio}
                // Need to check for @refs.audio? because it's apparently undefined while
                // unmounting and breaks if try to pause audio during unmount.
                onRequestPauseAudio={() => {
                  if (this.refs.audio != null) {
                    return this.pauseAudio();
                  }
                }}
              />
            ) : undefined}
          </div>
          <span className="sbs-protocol-name">{this.props.protocol.name}</span>
        </div>
        <CSSTransitionGroup
          component="div"
          transitionName="transition-sbs-fade"
          transitionEnterTimeout={TransitionConstants.TRANSITION_FADE_DURATION_MS}
          transitionLeaveTimeout={TransitionConstants.TRANSITION_FADE_DURATION_MS}
        >
          {children}
        </CSSTransitionGroup>
      </div>
    );
  },
});

export default ProtocolStepByStep;
